import { render, staticRenderFns } from "./RolesSelector.vue?vue&type=template&id=35bdc50e&scoped=true"
import script from "./RolesSelector.vue?vue&type=script&lang=js"
export * from "./RolesSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35bdc50e",
  null
  
)

export default component.exports